export default __webpack_public_path__ + "static/media/13.7be1ad52.png";